import { has } from 'lodash'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import pageMessages from '@/pages/SpaceAnalyticsPage/messages'
import MessagesIcon from '@/pages/SpaceAnalyticsPage/util/icons/MessagesIcon'
import SessionsIcon from '@/pages/SpaceAnalyticsPage/util/icons/SessionsIcon'
import UserIcon from '@/pages/SpaceAnalyticsPage/util/icons/UserIcon'
import MetricHorizontalSection from '@/pages/SpaceAnalyticsPage/util/MetricHorizontalSection'

import messages from './messages'

const ChatMetricsSection = ({ chatMetrics, previousChatMetrics }: any) => {
  return (
    <div className="analytics-section">
      <div className="metric-card-subheader">
        <h3>
          <FormattedMessage {...messages.title} />
        </h3>
        {hasData(chatMetrics) && (
          <span className="sub-text">
            <FormattedMessage {...messages.titleSubText} />
          </span>
        )}
      </div>
      {hasData(chatMetrics) ? (
        <div className="metric-horizontal-holder">
          <MetricHorizontalSection
            icon={<UserIcon />}
            label={<FormattedMessage {...messages.uniqueMembers} />}
            value={chatMetrics.members}
            differenceValue={previousChatMetrics && previousChatMetrics.members}
          />
          <MetricHorizontalSection
            icon={<MessagesIcon />}
            label={<FormattedMessage {...messages.totalMessages} />}
            value={chatMetrics.messages}
            differenceValue={previousChatMetrics && previousChatMetrics.messages}
          />
          <MetricHorizontalSection
            icon={<SessionsIcon />}
            label={<FormattedMessage {...messages.sessions} />}
            value={chatMetrics.sessions}
            differenceValue={previousChatMetrics && previousChatMetrics.sessions}
          />
        </div>
      ) : (
        <p className="flex-center">
          <FormattedMessage {...pageMessages.noActivityMetrics} />
        </p>
      )}
    </div>
  )
}

ChatMetricsSection.displayName = 'ChatMetricsSection'

ChatMetricsSection.propTypes = {
  chatMetrics: PropTypes.object.isRequired,
  previousChatMetrics: PropTypes.object
}

ChatMetricsSection.defaultProps = {
  previousChatMetrics: {}
}

const hasData = (metricData: any) => {
  if (
    has(metricData, 'members') &&
    has(metricData, 'messages') &&
    has(metricData, 'sessions') &&
    dataIsAvailable(metricData)
  )
    return true
  return false
}

const dataIsAvailable = (metricData: any) => {
  if (metricData.members === 0 && metricData.messages === 0 && metricData.sessions === 0) return false
  return true
}

export default ChatMetricsSection
